/**
 * Diese Komponente bindet dann das jeweilige Modul ein, übergibt den User, sowie die verfügbaren Socialmediakanäle und die jeweiligen Pfade und Token.
 */

import 'regenerator-runtime/runtime'
import React from 'react'
import { Provider, useSelector } from 'react-redux'

import { UserSettings } from '@professocialApi/professocial-core-frontend-api'
import { accountRootReducer } from '@professocial/professocialAccounts/src/store/accountRoot.reducer'
import { accountRootSaga } from '@professocial/professocialAccounts/src/store/accountRoot.sagas'
import ProfessocialAccounts from '@professocial/professocialAccounts/src/screens/ProfessocialAccounts'
import { getLanguages, getTheme, getUser } from '../../../store/common/common.selectors'
import { Theme } from '@mui/material'
import createSagaMiddleware from 'redux-saga'
import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from '@redux-devtools/extension'

const sagaMiddleware = createSagaMiddleware()
const storeAccounts = createStore(
  accountRootReducer,
  composeWithDevTools(
    applyMiddleware(sagaMiddleware),
  ),
)

sagaMiddleware.run(accountRootSaga)

const EditorAccounts: React.FC = () => {
  const theme: Theme = useSelector(getTheme)
  const user: UserSettings | undefined = useSelector(getUser)
  const language = useSelector(getLanguages)

  return (
    <Provider store={storeAccounts}>
      <ProfessocialAccounts accountConfiguration={{ theme, user, language }} />
    </Provider>
  )
}
export default EditorAccounts
